import history from '../../../../../history'
import { useDispatch, useSelector } from 'react-redux'
import { FormattedMessage } from 'react-intl'
import { Button, Text } from '../../../..'
import { ButtonProps } from '../../../../shared/Button/Button'
import { selectClientIsGuest } from '../../../../../store/selectors/client'
import { toggleAuthModal } from '../../../../../actions/homeSearchAuthModal'
import { IconBolt } from '../../../../shared/Icon'
import classNames from 'classnames'
import { setScheduleTourShowModal } from '../../../../../store/slices/scheduleTour'

import styles from './ScheduleTourButton.module.scss'

const ScheduleTourButton = ({
  className,
  primary = false,
  primaryCustom = false,
}: ButtonProps) => {
  const dispatch = useDispatch()
  const isGuest = useSelector(selectClientIsGuest)

  const handleTour = () => {
    if (isGuest) {
      history.push(`?redirectUrl=${window.location.href}`)
      dispatch(toggleAuthModal(true))
    } else {
      dispatch(setScheduleTourShowModal(true))
    }
  }

  return (
    <Button
      onClick={handleTour}
      className={classNames(styles.tourBtn, className)}
      iconStart={IconBolt}
      primary={primary}
      primaryCustom={primaryCustom}
    >
      <Text element='span' className={styles.smallScreen} weight='semibold'>
        <FormattedMessage
          id='ScheduleTourButton.shortCta'
          defaultMessage='Tour'
        />
      </Text>
      <Text element='span' weight='semibold' className={styles.mediumScreen}>
        <FormattedMessage
          id='ScheduleTourButton.longCta'
          defaultMessage='Schedule a tour'
        />
      </Text>
    </Button>
  )
}

export default ScheduleTourButton
